import React from "react";
import styles from "./QuestionHeadingStyles.module.css";
import classnames from "classnames";
import { QUESTION_TYPE_MAPPING } from "features/Account/modules/Communications/modules/ContactForm/modules/QuestionForm/modules/common/QuestionFormFields/constants/QuestionFormFields.constants";

export const QuestionHeading = ({ record = {} }) => {
  return (
    <div className={styles.questionWrapper}>
      <div className={classnames(styles.questionHeading, "ellipsis")}>
        {record.question}
      </div>
      <div className={styles.questionType}>
        {QUESTION_TYPE_MAPPING[record.type]?.label}
      </div>
    </div>
  );
};
